import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2b74e8d9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "LogicalTransformer2DContainer"
};
const _hoisted_2 = {
  class: "flex justify-center pb-4"
};
const _hoisted_3 = {
  class: "text-2xl"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "根据题目所示的四组变换前、后图形，推断操作 1~操作 4 对应的变换过程，并选择图例依次经过操作 1~操作 4 变换后的结果。", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "如果黑格重叠了就融合在一起， 不再分开， 黑子移动到一端后再向该侧移动可以从另一端出现", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex justify-center p-2"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "text-2xl"
}, "变换规则")], -1));
const _hoisted_7 = {
  class: "flex flex-col justify-center"
};
const _hoisted_8 = {
  key: 0,
  class: "px-4"
};
const _hoisted_9 = {
  key: 1,
  class: "px-4"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex justify-center p-2"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "text-2xl"
}, "题目")], -1));
const _hoisted_11 = {
  class: "flex justify-center"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex justify-center p-2"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "text-2xl"
}, "请选择答案")], -1));
const _hoisted_13 = {
  class: "pb-2"
};
const _hoisted_14 = {
  key: 1,
  class: "flex flex-wrap items-center"
};
const _hoisted_15 = {
  class: "p-4"
};
const _hoisted_16 = {
  class: "px-4"
};
const _hoisted_17 = {
  class: "p-4"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LogicalTransformer2DImg = _resolveComponent("LogicalTransformer2DImg");
  const _component_AnswerButtonGroup = _resolveComponent("AnswerButtonGroup");
  const _component_el_row = _resolveComponent("el-row");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, "第" + _toDisplayString($props.question.questionIndex + 1) + "题", 1)]), _hoisted_4, _hoisted_5, _hoisted_6, _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.question.example, (e, ei) => {
    return _openBlock(), _createElementBlock("div", {
      key: `e_${ei}`,
      class: "flex justify-center items-center p-2"
    }, [_createVNode(_component_LogicalTransformer2DImg, {
      grid: e.beforeTransformer
    }, null, 8, ["grid"]), $props.reviewMode ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString($data.transformers[e.operate]) + " 👉🏻", 1)) : (_openBlock(), _createElementBlock("span", _hoisted_9, "操作" + _toDisplayString(ei + 1) + " 👉🏻", 1)), _createVNode(_component_LogicalTransformer2DImg, {
      grid: e.afterTransformer
    }, null, 8, ["grid"])]);
  }), 128))]), _hoisted_10, _createElementVNode("div", _hoisted_11, [_createVNode(_component_LogicalTransformer2DImg, {
    grid: $props.question.question
  }, null, 8, ["grid"])]), _hoisted_12, _createVNode(_component_AnswerButtonGroup, {
    options: $data.OPTIONS,
    review: $props.review,
    reviewMode: $props.reviewMode,
    onChoose: $options.onChoosed,
    ref: "LogicalTransformer2DAnswer"
  }, {
    default: _withCtx(btnIndex => [_createElementVNode("div", _hoisted_13, [_createVNode(_component_LogicalTransformer2DImg, {
      grid: $props.question.options[btnIndex.index]
    }, null, 8, ["grid"])])]),
    _: 1
  }, 8, ["options", "review", "reviewMode", "onChoose"]), $props.reviewMode ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "colFlex bothCenter mt32"
  }, {
    default: _withCtx(() => [_createElementVNode("span", null, "正确答案：" + _toDisplayString($props.question.rightAnswer), 1), $props.review ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      style: _normalizeStyle({
        color: $props.review.result ? 'green' : 'red'
      })
    }, "您的答案：" + _toDisplayString($props.review.answer), 5)) : _createCommentVNode("", true)]),
    _: 1
  })) : _createCommentVNode("", true), $props.reviewMode ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_LogicalTransformer2DImg, {
    grid: $props.question.question
  }, null, 8, ["grid"])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.question.steps, (s, si) => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: `step_${si}`
    }, [_createElementVNode("span", _hoisted_16, "-> " + _toDisplayString($data.transformers[$props.question.example[si].operate]) + " ->", 1), _createElementVNode("div", _hoisted_17, [_createVNode(_component_LogicalTransformer2DImg, {
      grid: s
    }, null, 8, ["grid"])])], 64);
  }), 128))])) : _createCommentVNode("", true)]);
}